<template>
  <div class="editPage">
    <div class="head flex-rowl">
      <div class="icon"><i class="iconfont icon-wodexinxi_jibenxinxi"></i></div>
      <div class="con">
        <p>个人信息</p>
        <p>个人信息编辑管理</p>
      </div>
    </div>
    <div class="myInfoList">
      <div class="infoItem logo_wrap column" v-if="false">
        <div class="label">头像</div>
        <div class="upload_box flex-rowc">
          <div v-if="initData.headimg">
            <van-image width="100%" height="100%" :src="initData.headimg" />
            <div class="del-icon flex-rowc" @click="handleDelImg(1)">
              <van-icon name="delete-o" />
            </div>
          </div>
          <div class="no flex-rowc" v-else>
            <van-image
              width="100%"
              height="100%"
              :src="require('../../assets/images/user-tx.png')"
            />
            <input
              type="file"
              class="uploadInput"
              ref="fileInput1"
              accept="image/*"
              @change="handleChooseImg(1)"
            />
          </div>
        </div>
      </div>
      <div class="infoItem">
        <div class="label flex-rowl">
          <p class="icon_box flex-rowc">
            <i class="iconfont icon-xingmingyonghumingnicheng"></i>
          </p>
          昵称
        </div>
        <div class="input">
          <van-field
            v-model="initData.nickname"
            placeholder="请输入企业名称，30个字符内"
            maxlength="30"
          />
        </div>
      </div>
      <div class="infoItem">
        <div class="label flex-rowl">
          <p class="icon_box flex-rowc">
            <i class="iconfont icon-xingmingyonghumingnicheng"></i>
          </p>
          姓名
        </div>
        <div class="input">
          <van-field
            v-model="initData.truename"
            placeholder="请输入你的姓名，2～30个字符内"
            maxlength="30"
          />
        </div>
      </div>
      <div class="infoItem">
        <div class="label flex-rowl">
          <p class="icon_box flex-rowc">
            <i class="iconfont icon-shoujihaoma"></i>
          </p>
          工作手机
        </div>
        <div class="input">
          <van-field
            v-model="otherData.mobile"
            placeholder="请输入你的工作手机号"
            maxlength="30"
          />
        </div>
      </div>
      <div class="infoItem">
        <div class="label flex-rowl">
          <p class="icon_box flex-rowc">
            <i class="iconfont icon-weixin"></i>
          </p>
          工作微信ID
        </div>
        <div class="input">
          <van-field
            v-model="otherData.weixin"
            placeholder="请输入你的工作微信ID，30个字符以内"
            maxlength="30"
          />
        </div>
      </div>
      <div class="infoItem">
        <div class="label flex-rowl">
          <p class="icon_box flex-rowc">
            <i class="iconfont icon-gender"></i>
          </p>
          性别
        </div>
        <div class="input flex-between" @click="handleShow(1)">
          <van-field readonly v-model="initData.sex" placeholder="未知" />
          <van-icon name="arrow" class="arrow" />
        </div>
      </div>
      <div class="infoItem">
        <div class="label flex-rowl">
          <p class="icon_box flex-rowc">
            <i class="iconfont icon-nianling"></i>
          </p>
          年龄
        </div>
        <div class="input flex-between">
          <van-field v-model="initData.age" placeholder="暂无" />
        </div>
      </div>
      <div class="address_wrap column">
        <div class="infoItem">
          <div class="label flex-rowl">
            <p class="icon_box flex-rowc">
              <i class="iconfont icon-dizhiguanli"></i>
            </p>
            所在地区
          </div>
          <div class="input flex-between" @click="handleShow(3)">
            <van-field
              readonly
              v-model="provinceTxt"
              placeholder="选择省/直辖市"
            />
            <van-icon name="arrow" class="arrow" />
          </div>
        </div>
        <div class="infoItem">
          <div class="input flex-between" @click="handleShow(4)">
            <van-field readonly v-model="cityTxt" placeholder="选择城市" />
            <van-icon name="arrow" class="arrow" />
          </div>
        </div>
        <div class="infoItem">
          <div class="input flex-between" @click="handleShow(5)">
            <van-field readonly v-model="areaTxt" placeholder="选择所在区域" />
            <van-icon name="arrow" class="arrow" />
          </div>
        </div>
        <div class="infoItem detail textarea">
          <div class="label">详细区域描述</div>
          <div class="text textArea_box">
            <van-field
              type="textarea"
              v-model="initData.addr"
              placeholder="请输入详细描述，50个字符以内"
              maxlength="50"
            />
          </div>
        </div>
      </div>
      <div class="agree_wrapper flex-rowl">
        <van-checkbox
          v-model="checked"
          shape="square"
          checked-color="#F62560"
          class="check"
        />WINK SShoWP的 <agree></agree>
      </div>
      <div class="custom_btn" @click="handleSave">保存</div>
    </div>

    <div class="custom_btn fixed" @click="handleReturn">←返回</div>

    <!-- 弹窗 start -->
    <van-popup v-model="isShow" position="bottom" :style="{ height: '40%' }">
      <!-- 行业标签1 -->
      <div v-if="isType == 1">
        <van-picker
          show-toolbar
          :columns="genderArr"
          @confirm="onConfirm"
          @cancel="isShow = false"
        />
      </div>
      <div v-else-if="isType == 3">
        <van-picker
          show-toolbar
          :columns="provinceList"
          @confirm="onConfirm"
          @cancel="isShow = false"
          :loading="loading"
          v-if="provinceList.length > 0"
        />
        <van-empty
          v-else-if="provinceList.length == 0 && !loading"
          description="暂无选项"
        />
      </div>
      <div v-else-if="isType == 4">
        <van-picker
          show-toolbar
          :columns="cityList"
          @confirm="onConfirm"
          @cancel="isShow = false"
          :loading="loading"
          v-if="cityList.length > 0"
        />
        <van-empty
          v-else-if="cityList.length == 0 && !loading"
          description="暂无选项"
        />
      </div>
      <div v-else-if="isType == 5">
        <van-picker
          show-toolbar
          :columns="areaList"
          @confirm="onConfirm"
          @cancel="isShow = false"
          :loading="loading"
          v-if="areaList.length > 0"
        />
        <van-empty
          v-else-if="areaList.length == 0 && !loading"
          description="暂无选项"
        />
      </div>
    </van-popup>
    <!-- 弹窗 end -->
  </div>
</template>

<script>
import {
  getProvince,
  getCity,
  getArea,
  uploadImage,
  getUserInfo,
} from "../../api/api";
import { updateUserInfo, updateUserExtInfo } from "../../api/user";
import storage from "../../utils/storage";
import agree from "../../components/Agreement.vue";
export default {
  name: "companyEdit",
  components: {
    agree,
  },
  data() {
    return {
      // 提交数据
      initData: {
        openid: "",
        headimg: "",
        nickname: "",
        truename: "",
        sex: "",
        age: "",
        province: "",
        city: "",
        area: "",
        addr: "",
      },
      // 扩展信息
      otherData: {
        openid: "",
        mobile: "",
        weixin: "",
        mobile2: "",
        intro: "",
      },

      genderArr: ["男", "女"],

      // minDate: new Date(1700, 0, 1),
      // maxDate: new Date(2040, 10, 1),
      // currentDate: new Date(),

      provinceList: [],
      provinceTxt: "",
      cityList: [],
      cityTxt: "",
      areaList: [],
      areaTxt: "",

      loading: true,
      columns: [],
      isType: 1,
      isShow: false,

      uploadType: 1,
      checked: false,
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      let res = this.$store.state.USERINFO;
      this.initData.openid = res.openid ? res.openid : "";
      this.initData.headimg = res.headimg ? res.headimg : "";
      this.initData.nickname = res.nickname ? res.nickname : "";
      this.initData.truename = res.truename ? res.truename : "";
      this.initData.age = res.age ? res.age : "";
      this.initData.sex = res.sex ? res.sex : "";

      this.initData.province = res.province ? res.province : "";
      this.provinceTxt = res.provincename ? res.provincename : "";

      this.initData.area = res.area ? res.area : "";
      this.areaTxt = res.areaname ? res.areaname : "";

      this.initData.city = res.city ? res.city : "";
      this.cityTxt = res.cityname ? res.cityname : "";

      this.initData.addr = res.addr ? res.addr : "";

      this.otherData.openid = res.openid ? res.openid : "";
      this.otherData.mobile2 = res.mobile ? res.mobile : "";
      if (res.tuozhan.length > 0) {
        this.otherData.weixin = res.tuozhan[0].weixin
          ? res.tuozhan[0].weixin
          : "";
        this.otherData.mobile = res.tuozhan[0].mobile
          ? res.tuozhan[0].mobile
          : "";
        this.otherData.intro = res.tuozhan[0].intro ? res.tuozhan[0].intro : "";
      }
    },

    // 获取城市
    getProvince(isClick) {
      getProvince().then((res) => {
        let newProvince = [];
        res.forEach((v) => {
          newProvince.push({
            text: v.areaname,
            id: v.areaid,
          });
        });
        this.provinceList = newProvince;
        this.loading = false;
        if (isClick) {
          this.isShow = true;
        }
      });
    },
    // 获取城市
    getCity(isClick) {
      getCity(this.initData.province).then((res) => {
        let newcity = [];
        res.forEach((v) => {
          newcity.push({
            text: v.cityname,
            id: v.cityid,
          });
        });
        this.cityList = newcity;
        this.loading = false;
        if (isClick && newcity.length > 0) {
          this.isShow = true;
        } else {
          this.$toast("暂无数据");
        }
      });
    },
    // 获取区域
    getArea(isClick) {
      getArea(this.initData.city).then((res) => {
        let newarea = [];
        res.forEach((v) => {
          newarea.push({
            text: v.addrname,
            id: v.addrid,
          });
        });
        this.areaList = newarea;
        this.loading = false;
        console.log(newarea,'====newareanewareanewarea');
        if (isClick && newarea.length > 0) {
          this.isShow = true;
        } else {
          this.$toast("暂无数据");
        }
      });
    },

    onConfirm(e) {
      let { isType } = this;
      if (isType == 1) {
        this.initData.sex = e;
      } else if (isType == 3) {
        this.provinceTxt = e.text;
        this.initData.province = e.id;
        this.areaTxt = "";
        this.initData.area = "";
        this.cityTxt = "";
        this.initData.city = "";
        this.initData.addr = "";
      } else if (isType == 4) {
        this.cityTxt = e.text;
        this.initData.city = e.id;
        this.areaTxt = "";
        this.initData.area = "";
        this.initData.addr = "";
      } else if (isType == 5) {
        this.areaTxt = e.text;
        this.initData.area = e.id;
        this.initData.addr = "";
      }
      this.loading = true;
      this.isShow = false;
    },
    // 显示弹窗
    handleShow(type) {
      let { provinceTxt, cityTxt } = this;
      this.isType = type;
      if (type == 1) {
        this.isShow = true;
      } else if (type == 2) {
        this.isShow = true;
      } else if (type == 3) {
        this.getProvince(true);
      } else if (type == 4) {
        if (provinceTxt == "") {
          this.$toast("请选择省/直辖市");
          return;
        }
        this.getCity(true);
      } else if (type == 5) {
        if (provinceTxt == "") {
          this.$toast("请选择省/直辖市");
          return;
        }
        if (cityTxt == "") {
          this.$toast("请选择城市");
          return;
        }
        this.getArea(true);
      }
    },

    // 上传图片
    handleChooseImg(uploadType) {
      const toast = this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
      });
      const formData = new FormData();
      if (uploadType == 1) {
        formData.append("imgfile", this.$refs.fileInput1.files[0]);
      } else if (uploadType == 2) {
        formData.append("imgfile", this.$refs.fileInput2.files[0]);
      }
      uploadImage(formData).then((res) => {
        if (res.result) {
          if (uploadType == 1) {
            this.initData.headimg = res.url;
          }
          toast.clear();
        } else {
          this.$toast.fail("上传失败");
        }
      });
    },
    // 删除图
    handleDelImg(type) {
      if (type == 1) {
        this.initData.headimg = "";
      }
    },

    // 返回上一页
    handleReturn() {
      this.$router.go(-1);
    },
    async handleSave() {
      let { truename } = this.initData;
      const toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      if (truename === "") {
        this.$toast("请输入姓名！");
        return;
      }

      if (!this.checked) {
        this.$toast("请阅读条款");
        return;
      }
      let params = this.initData;
      let params1 = this.otherData;
      let res1 = await updateUserInfo(params);
      let res2 = await updateUserExtInfo(params1);
      if (res1.result && res2.result) {
        this.$toast.success(res1.message);
        toast.clear();
        this.getUserInfo();
      } else {
        toast.clear();
        this.$toast.fail(res1.message);
      }
    },

    getUserInfo() {
      getUserInfo({ openid: this.$store.state.OPENID }).then((res) => {
        if (Object.keys(res).length > 0) {
          setTimeout(() => {
            this.$router.back();
          }, 500);
          this.$store.commit("updateUserInfo", res);
        } else {
          storage.removeAll();
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.editPage {
  padding-bottom: 240px;
  box-sizing: border-box;
  font-size: 28px;
  background: #fafafa;
  .head {
    padding: 145px 0 30px 75px;
    box-sizing: border-box;
    .iconfont {
      font-size: 46px;
      margin-right: 15px;
    }
    p {
      font-size: 30px;
      color: #333333;
      &:last-child {
        font-size: 20px;
        margin-top: 5px;
      }
    }
  }
  /deep/ .van-cell {
    padding: 0;
    background: none;
  }
  .myInfoList {
    background: #fff;
    // padding: 40px 42px 120px;
    padding: 75px 75px 120px;
    // width: 600px;
    .infoItem {
      margin: 0 0 42px;
      font-size: 24px;
      .label {
        color: #444444;
        white-space: nowrap;
        // margin-right: 40px;
        margin-bottom: 22px;
        span {
          color: #ff0000;
          margin-right: 5px;
          margin-left: -5px;
        }
        .iconfont {
          font-size: 12px !important;
        }
      }
      .input {
        // padding: 15px 10px 0;
        height: 55px;
        flex: 1;
        font-size: 20px;
        padding-left: 10px;
        border-bottom: 2px dashed #d9d9d9;
      }
      /deep/ .van-field__control {
        font-size: 12px;
      }
      .textarea {
        padding: 0 10px;
        border-bottom: 2px dashed #d9d9d9;
      }
      &.detail {
        margin-top: 74px;
        .textArea_box {
          background: #fafafa;
          padding: 10px;
          box-sizing: border-box;
        }
      }
    }
    .upload_wrap {
      padding-bottom: 115px;
      .label {
        margin-bottom: 66px;
      }
      .upload_box {
        width: 300px;
        height: 300px;
        margin: auto;
        border: 2px dashed #d9d9d9;
        position: relative;
        overflow: hidden;
        background: #ffffff;
        .no {
          width: 100%;
          height: 100%;
          position: relative;
          /deep/ .van-uploader,
          /deep/ .van-uploader__wrapper,
          /deep/ .van-uploader__upload {
            width: 100%;
            height: 100%;
            margin: auto;
          }
          .uploadInput {
            position: absolute;
            width: 100%;
            height: 100%;
            opacity: 0;
            z-index: 1001;
          }
        }
        .del-icon {
          position: absolute;
          bottom: 0;
          right: 0;
          width: 0;
          height: 0;
          border-top: 30px solid transparent;
          border-right: 30px solid #ff0000;
          border-bottom: 30px solid red;
          border-left: 30px solid transparent;
          color: #fff;
        }
      }
    }
    .column {
      .title {
        font-size: 34px;
        font-weight: bold;
        padding: 40px 0 20px;
      }
    }
    .industry_wrap {
      margin-bottom: 90px;
    }
    // .address_wrap {
    //   margin-bottom: 90px;
    // }
  }
  .agree_wrapper {
    font-size: 20px;
    padding: 120px 0 80px 0;
    .check {
      margin-right: 15px;
    }
  }
}
</style>